import { Injectable } from '@angular/core';
import { FirebaseData } from '../../../providers/firebase-data';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { Observable } from 'rxjs/Observable';
import { FireBaseObjectNames } from '../../../core/codes';
import { Storage } from '@ionic/storage'; 
import { Utils } from '../../../providers/utils';
import firebase from 'firebase';

@Injectable()
export class ShoppingListData {
    public realtimeDb: any;

    constructor(
        private firebaseData: FirebaseData, 
        private firebaseStorage: FirebaseStorage,
        private storage: Storage
        ) {
      this.realtimeDb = firebase.database();
    }

     public getShoppingItems(userId) {
        var self = this;
       
        return Observable.create((observer) => {
            self.realtimeDb.ref(FireBaseObjectNames.SHOPPING_ITEMS+ '/' + userId).once('value', data => {
                let items = [];
                if (data) {
                    items = Utils.toArray(data.val());
                    items = items.reverse();
                }
                observer.next(items);
            });
        });
        
    }
}


// WEBPACK FOOTER //
// ./src/modules/account/providers/shopping-list-data.ts